import React, {useCallback} from "react";
import styled, {css} from "styled-components";
import colors from "../../const/style/colors";
import fonts from "../../const/style/fonts";
import DEFAULT_THUMB_IMG from "../../assets/defaultImg/default_ppt_thumb_image.svg";
import {IPTImage} from "../../interfaces/IPTInformation";

const StyledRootLi = styled.li<{
    playing?: boolean,
    tempSelected?: boolean
}>`
  position:relative;
  padding-left:24px;
  margin-bottom:1rem;
  cursor:pointer;
  
  &:before {
    ${fonts.presentation_thumb_number};
    position:absolute;
    top:0;
    left:0;
    margin-left:6px;
    min-width:12px;
    overflow-x:visible;
    text-align:center;
    counter-increment:slide;
    content:counter(slide);
  }
  img{
    width:100%;
    height:100%;
    object-fit:scale-down;
  }
  .slide-thumb {
    position: relative;
    width:126px;
    min-height: 69px;
    border: 1px solid ${colors.CCCCCCC};
    display:flex;
    justify-content:center;
    align-items:center;
    ${({tempSelected}) => tempSelected && css`
      border: 3px solid ${colors.C000000};        
    `}
  }
  overflow-y: auto;
`;
const StyledActiveDot = styled.div`
    position: absolute;
    top: 17px;
    left: 0;
    margin-left: 8px;
    overflow-x: visible;
    text-align: center;
    border: none;
    width: 8px;
    height: 8px;
    border-radius: 100%;
    background: #2CBFA3;
`;

const StyledSelectedBackground = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    ${
        (props) => (props as any)['data-selected'] &&
        'background: #2CBFA39F'
    }
`;

interface ISlideThumbListProps {
    className?: string;
    playing?: boolean;
    tempSelected?: boolean;
    image: IPTImage;
    onClick?: (image: IPTImage) => void;
    srcURLPrefix?: string;
    alt?: string;
}

const SlideThumbItem: React.FC<ISlideThumbListProps> = ({
                                                            className,
                                                            onClick,
                                                            playing,
                                                            image,
                                                            tempSelected,
                                                            srcURLPrefix = '',
                                                            alt
                                                        }) => {

    const handleClick = useCallback(() => onClick?.(image), [onClick, image]);
    return (
        <StyledRootLi className={className}
                      onClick={handleClick}
                      playing={playing}
                      tempSelected={tempSelected}>
            {
                !playing ||
                <StyledActiveDot/>
            }
            <div className="slide-thumb">
                <StyledSelectedBackground data-selected={playing}></StyledSelectedBackground>
                <img src={`${image.fileUrl}`} alt={alt} onError={(e: any) => {
                {/*<img src={`${srcURLPrefix}api/file/${image.id}`} alt={alt} onError={(e: any) => {*/}
                    e.currentTarget.src = DEFAULT_THUMB_IMG;
                }}/>
            </div>
        </StyledRootLi>
    )
};

export default SlideThumbItem;
